function throttle(self, params = {}) {
    clearTimeout(self.timer);
    self.timer = setTimeout(() => {
        typeof params.callback == 'function' && params.callback()
    }, params.delay || 500)
}
module.exports = {
    throttle
}